/** Default Journey topic on Life on Life osTicket (“Open a new ticket”). */
export const DEFAULT_LIFE_ON_LIFE_TICKET_URL =
  'https://support.lifeonlife.org/open.php?topicId=20&lang=en_US'

/** Life on Life knowledge base, opened by the "?" (FAQ) menu items. */
export const DEFAULT_LIFE_ON_LIFE_KB_URL =
  'https://support.lifeonlife.org/kb/index.php'
